// Angular
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { APP_INITIALIZER , NgModule, ErrorHandler } from '@angular/core';
//import { MAT_DATE_LOCALE,MatDatepicker,DateAdapter,MAT_DATE_FORMATS,MatDatepickerModule, MatNativeDateModule } from '@angular/material';
//import { MAT_MOMENT_DATE_ADAPTER_OPTIONS,MatMomentDateModule } from '@angular/material-moment-adapter';

//import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter,MatMomentDateModule,MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
//import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,MatDatepickerModule} from '@angular/material';

import {DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS,MatNativeDateModule,MatDatepickerModule} from '@angular/material';
import {MomentDateAdapter, MAT_MOMENT_DATE_FORMATS, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { LOCALE_ID } from '@angular/core';

import 'moment/locale/fr';

import { MatInputModule, MatPaginatorModule, 
		 MatSortModule, MatRadioModule, MatTableModule } from "@angular/material";

import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GestureConfig, MatProgressSpinnerModule } from '@angular/material';
import { OverlayModule } from '@angular/cdk/overlay';
import { ReactiveFormsModule }          from '@angular/forms';
import { FormsModule }   from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import { NgxElectronModule } from 'ngx-electron';

import localeFr from '@angular/common/locales/fr';

// Angular in memory
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
// NgBootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Perfect Scroll bar
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
// Env
import { environment } from '../environments/environment';
// Hammer JS
import 'hammerjs';
// NGX Permissions
import { NgxPermissionsModule } from 'ngx-permissions';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// State
import { metaReducers, reducers } from './core/reducers';
// Copmponents
import { AppComponent } from './app.component';
// Modules
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
// Partials
import { PartialsModule } from './views/partials/partials.module';
import { DesignModule } from './views/partials/design/design.module';
// Services
import { DataTableService, FakeApiService } from './core/_base/layout';
// Layout Services
import { LayoutConfigService, LayoutRefService, MenuAsideService, MenuConfigService, MenuHorizontalService, PageConfigService, SplashScreenService, SubheaderService,
	KtDialogService } from './core/_base/layout';
// Auth
import { AuthModule } from './views/pages/auth/auth.module';
import { AuthService } from './core/auth';
// CRUD
import { HttpUtilsService, LayoutUtilsService, TypesUtilsService } from './core/_base/crud';
// Config
import { LayoutConfig } from './core/_config/demo1/layout.config';
// Highlight JS
import { HIGHLIGHT_OPTIONS, HighlightLanguage } from 'ngx-highlightjs';
import * as typescript from 'highlight.js/lib/languages/typescript';
import * as scss from 'highlight.js/lib/languages/scss';
import * as xml from 'highlight.js/lib/languages/xml';
import * as json from 'highlight.js/lib/languages/json';

import { AppService } from './services/app.service';
import { StateService } from './services/state.service';
import { UtilitaryService } from './services/utilitary.service';
import { ParameterService } from './services/parameter.service';
import { ErrorsHandler } from './services/ErrorHandler';
import { DialogService } from './services/dialog-service.service';

console.log('loacale',localeFr);
registerLocaleData(localeFr, 'fr');

// tslint:disable-next-line:class-name
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	wheelSpeed: 0.5,
	swipeEasing: true,
	minScrollbarLength: 40,
	maxScrollbarLength: 300,
};

export function initializeLayoutConfig(appConfig: LayoutConfigService) {
	// initialize app by loading default demo layout config
	return () => {
		if (appConfig.getConfig() === null) {
			appConfig.loadConfigs(new LayoutConfig().configs);
		}
	};
}

export function hljsLanguages(): HighlightLanguage[] {
	return [
		{name: 'typescript', func: typescript},
		{name: 'scss', func: scss},
		{name: 'xml', func: xml},
		{name: 'json', func: json}
	];
}

@NgModule({
	declarations: [
		AppComponent],
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		environment.isMockEnabled ? HttpClientInMemoryWebApiModule.forRoot(FakeApiService, {
			passThruUnknownUrl: true,
			dataEncapsulation: false
		}) : [],
		NgxPermissionsModule.forRoot(),
		PartialsModule,
		CoreModule,
		OverlayModule,
		StoreModule.forRoot(reducers, {metaReducers}),
		EffectsModule.forRoot([]),
		StoreRouterConnectingModule.forRoot({stateKey: 'router'}),
		StoreDevtoolsModule.instrument(),
		AuthModule.forRoot(),
		NgbModule,
		TranslateModule.forRoot(),
		MatProgressSpinnerModule,
		InlineSVGModule.forRoot(),
		ReactiveFormsModule,
		FormsModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatInputModule,
		MatPaginatorModule, 
		MatSortModule,
		MatTableModule,
		MatRadioModule,
		NgxElectronModule,
        DesignModule
	],
	exports: [],
	providers: [
		AuthService,
		AppService,
		StateService,
		UtilitaryService,
		ParameterService,
		LayoutConfigService,
		LayoutRefService,
		MenuConfigService,
		PageConfigService,
		KtDialogService,
		DataTableService,
		SplashScreenService,
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		},
		 {
		 	provide: ErrorHandler,
		 	useClass: ErrorsHandler,
		 },
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: GestureConfig
		},
		{
			// layout config initializer
			provide: APP_INITIALIZER,
			useFactory: initializeLayoutConfig,
			deps: [LayoutConfigService], multi: true
		},
		{
			provide: HIGHLIGHT_OPTIONS,
			useValue: {languages: hljsLanguages}
		},
		// template services
		SubheaderService,
		MenuHorizontalService,
		MenuAsideService,
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService,
		{ provide: LOCALE_ID, useValue: 'fr-FR' },
		{ provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, 
			useValue: { useUtc: true } 
		},
		DialogService,
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
